// Move all constant arrays and config objects here
import PROMPTS from '../config/prompts';
export const LANGUAGES = [
  { key: 'ENGLISH', displayName: 'English' },
  { key: 'HINDI', displayName: 'हिंदी (Hindi)' },
  { key: 'HINGLISH', displayName: 'HINGLISH (Hindi + English)' }
];

// ================================
// PLATFORM CONFIGURATION
// ================================
export const WEB_CLIENT_ID = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID ||
  "1039681193782-obmnqsvo8dvct21i1fum6dov74i0iqn2.apps.googleusercontent.com";

export const CONTACT_NUMBER = '+91-8866822366';
export const WHATSAPP_NUMBER = '918866822366';

export const RELIGIONS = [
  { value: 'Hindu', label: 'Hindu', icon: '🕉️' },
  { value: 'Islam', label: 'Islam', icon: '☪️' },
  { value: 'Christianity', label: 'Christianity', icon: '✝️' },
  { value: 'Sikhism', label: 'Sikhism', icon: '☬' },
  { value: 'Buddhism', label: 'Buddhism', icon: '☸️' },
  { value: 'Jainism', label: 'Jainism', icon: '🤚' },
  { value: 'Judaism', label: 'Judaism', icon: '✡️' },
  { value: 'Zoroastrianism', label: 'Zoroastrianism', icon: '🔥' },
  { value: 'Other', label: 'Other', icon: '🌍' }
];

export const COUNTRIES = [
  { name: 'India', code: 'in', flag: '🇮🇳', timezone: 'Asia/Kolkata', utcOffset: '+05:30', abbreviation: 'IST', isdCode: '+91' },
  { name: 'Argentina', code: 'ar', flag: '🇦🇷', timezone: 'America/Argentina/Buenos_Aires', utcOffset: '-03:00', abbreviation: 'ART', isdCode: '+54' },
  { name: 'Australia', code: 'au', flag: '🇦🇺', timezone: 'Australia/Sydney', utcOffset: '+10:00', abbreviation: 'AEST', isdCode: '+61' },
  { name: 'Brazil', code: 'br', flag: '🇧🇷', timezone: 'America/Sao_Paulo', utcOffset: '-03:00', abbreviation: 'BRT', isdCode: '+55' },
  { name: 'Canada', code: 'ca', flag: '🇨🇦', timezone: 'America/Toronto', utcOffset: '-05:00', abbreviation: 'EST', isdCode: '+1' },
  { name: 'China', code: 'cn', flag: '🇨🇳', timezone: 'Asia/Shanghai', utcOffset: '+08:00', abbreviation: 'CST', isdCode: '+86' },
  { name: 'Denmark', code: 'dk', flag: '🇩🇰', timezone: 'Europe/Copenhagen', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+45' },
  { name: 'France', code: 'fr', flag: '🇫🇷', timezone: 'Europe/Paris', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+33' },
  { name: 'Germany', code: 'de', flag: '🇩🇪', timezone: 'Europe/Berlin', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+49' },
  { name: 'Italy', code: 'it', flag: '🇮🇹', timezone: 'Europe/Rome', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+39' },
  { name: 'Japan', code: 'jp', flag: '🇯🇵', timezone: 'Asia/Tokyo', utcOffset: '+09:00', abbreviation: 'JST', isdCode: '+81' },
  { name: 'Malaysia', code: 'my', flag: '🇲🇾', timezone: 'Asia/Kuala_Lumpur', utcOffset: '+08:00', abbreviation: 'MYT', isdCode: '+60' },
  { name: 'Mexico', code: 'mx', flag: '🇲🇽', timezone: 'America/Mexico_City', utcOffset: '-06:00', abbreviation: 'CST', isdCode: '+52' },
  { name: 'Netherlands', code: 'nl', flag: '🇳🇱', timezone: 'Europe/Amsterdam', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+31' },
  { name: 'New Zealand', code: 'nz', flag: '🇳🇿', timezone: 'Pacific/Auckland', utcOffset: '+12:00', abbreviation: 'NZST', isdCode: '+64' },
  { name: 'Norway', code: 'no', flag: '🇳🇴', timezone: 'Europe/Oslo', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+47' },
  { name: 'Saudi Arabia', code: 'sa', flag: '🇸🇦', timezone: 'Asia/Riyadh', utcOffset: '+03:00', abbreviation: 'AST', isdCode: '+966' },
  { name: 'Singapore', code: 'sg', flag: '🇸🇬', timezone: 'Asia/Singapore', utcOffset: '+08:00', abbreviation: 'SGT', isdCode: '+65' },
  { name: 'South Africa', code: 'za', flag: '🇿🇦', timezone: 'Africa/Johannesburg', utcOffset: '+02:00', abbreviation: 'SAST', isdCode: '+27' },
  { name: 'South Korea', code: 'kr', flag: '🇰🇷', timezone: 'Asia/Seoul', utcOffset: '+09:00', abbreviation: 'KST', isdCode: '+82' },
  { name: 'Spain', code: 'es', flag: '🇪🇸', timezone: 'Europe/Madrid', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+34' },
  { name: 'Sweden', code: 'se', flag: '🇸🇪', timezone: 'Europe/Stockholm', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+46' },
  { name: 'Switzerland', code: 'ch', flag: '🇨🇭', timezone: 'Europe/Zurich', utcOffset: '+01:00', abbreviation: 'CET', isdCode: '+41' },
  { name: 'Thailand', code: 'th', flag: '🇹🇭', timezone: 'Asia/Bangkok', utcOffset: '+07:00', abbreviation: 'ICT', isdCode: '+66' },
  { name: 'UAE', code: 'ae', flag: '🇦🇪', timezone: 'Asia/Dubai', utcOffset: '+04:00', abbreviation: 'GST', isdCode: '+971' },
  { name: 'United Kingdom', code: 'gb', flag: '🇬🇧', timezone: 'Europe/London', utcOffset: '+00:00', abbreviation: 'GMT', isdCode: '+44' },
  { name: 'United States', code: 'us', flag: '🇺🇸', timezone: 'America/New_York', utcOffset: '-05:00', abbreviation: 'EST', isdCode: '+1' }
];

export const MONTHS = [
  { value: 1, name: 'January' },
  { value: 2, name: 'February' },
  { value: 3, name: 'March' },
  { value: 4, name: 'April' },
  { value: 5, name: 'May' },
  { value: 6, name: 'June' },
  { value: 7, name: 'July' },
  { value: 8, name: 'August' },
  { value: 9, name: 'September' },
  { value: 10, name: 'October' },
  { value: 11, name: 'November' },
  { value: 12, name: 'December' }
];
export const currentYear = new Date().getFullYear();
export const YEARS = Array.from({ length: 100 }, (_, i) => currentYear - i);
export const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);

export const INITIAL_BIRTH_DETAILS = {
  full_name: '',
  religion: 'Hindu',
  birth_day: '',
  birth_month: '',
  birth_year: '',
  birth_time: '',
  birthtime: '',
  birth_place: '',
  timezone: 'Asia/Kolkata',
  country: 'India',
  country_code: 'in',
  mobile_number: '',
  country_code_no: '+91',
  timezoneAbbr: 'IST'
};

export const INITIAL_SELECTED_COUNTRY = {
  name: 'India',
  code: 'in',
  flag: '🇮🇳'
};

// ================================
// VALIDATION CONSTANTS
// ================================
export const MOBILE_NUMBER_MIN_LENGTH = 7;
export const MOBILE_NUMBER_MAX_LENGTH = 15;

// ================================
// ERROR MESSAGES
// ================================
export const ERROR_MESSAGES = {
  FULL_NAME: 'Please enter your full name',
  RELIGION: 'Please select your religion',
  BIRTH_DATE: 'Please select a valid birth date',
  BIRTH_TIME: 'Please select your birth time',
  BIRTH_PLACE: 'Please select your birth place',
  MOBILE_NUMBER: 'Please enter your mobile number',
  INVALID_MOBILE: 'Please enter a valid mobile number (7-15 digits)',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  AUTH_FAILED: 'Authentication failed. Please try again.'
};
// ================================
// SUCCESS MESSAGES
// ================================
export const SUCCESS_MESSAGES = {
  REGISTRATION: 'Registration successful! Logging you in...',
  LOGIN: 'Login successful!',
  SESSION_CREATED: 'Session created successfully'
};

// ================================
// STORAGE KEYS
// ================================
export const STORAGE_KEYS = {
  SESSION_ID: 'astroguru_session_id',
  USER_ID: 'astroguru_user_id',
  PENDING_REFERRAL: 'pending_referral_code',
  AUTH_TOKEN: 'astroguru_auth_token'
};

export const SEARCH_DEBOUNCE_DELAY = 300;
export const MESSAGE_AUTO_CLOSE_DELAY = 3000;
export const MODAL_TRANSITION_DELAY = 200;
// Import PROMPTS and allSuggestions as needed

export { PROMPTS };

// To avoid circular references, you can move allSuggestions here as well if needed
// export const allSuggestions = [...]; // your big array of suggestions